import React from 'react';
import styles from './SalesByCategoryCharts.module.scss';
import { QuantityByCategoryChart } from './Charts/QuantityByCategoryChart';
import { NetSalesByCategoryChart } from './Charts/NetSalesByCategoryChart';
import type { SalesByCategoryReport } from 'model/SalesByCategoryReport';

interface Props {
    loading: boolean;
    report: SalesByCategoryReport | null;
}

export const SalesByCategoryCharts: React.FC<Props> = ({ loading, report }) => {
    return (
        <div className={styles.root}>
            <div className={styles.grid}>
                <QuantityByCategoryChart
                    loading={loading}
                    report={report}
                />
                <NetSalesByCategoryChart
                    loading={loading}
                    report={report}
                />
            </div>
        </div>
    );
};

export default SalesByCategoryCharts;
